window.addEventListener('DOMContentLoaded', () => {
  const bodyElement = document.getElementsByTagName('body')[0];
  document.querySelectorAll('.modal-launch-on-load').forEach((modal) => {
    // eslint-disable-next-line no-undef
    const promoModal = new bootstrap.Modal(modal);
    if (!localStorage.getItem(modal.getAttribute('id'))) {
      localStorage.setItem(modal.getAttribute('id'), 'true');
      promoModal.toggle();
    }
  });

  setTimeout(() => {
    ['.sticky-top .modal', 'header .modal'].forEach((el) =>
      document.querySelectorAll(el).forEach((modal) => bodyElement.appendChild(modal))
    );
  }, 500);
});
